import * as React from "react";

function SvgPsr(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M8.5 28.333L4.25 34 0 28.333h2.833V21.25h2.834v7.083H8.5zM25.5 5.667L29.75 0 34 5.667h-2.833v7.083h-2.834V5.667H25.5zM2.833 11.333H0V7.792L7.792 0h3.541v2.833H8.5L2.833 8.5v2.833z"
        fill="#fff"
      />
      <path
        d="M7.083 11.333l4.25-4.25h15.584v19.834H7.083V11.333z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPsr;
